module.exports = ".filter-inputs {\n  margin-bottom: 15px !important; }\n\n.vessel-user-grid {\n  height: calc(100vh - 305px); }\n"